var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "pause-b",
    cx: 24,
    cy: 24,
    r: 20
  }), /*#__PURE__*/React.createElement("filter", {
    id: "pause-a",
    width: "132.5%",
    height: "132.5%",
    x: "-16.2%",
    y: "-13.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5cc9ca",
    filter: "url(#pause-a)",
    xlinkHref: "#pause-b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.5,
    fill: "#5cc9ca",
    stroke: "#5cc9ca",
    strokeLinejoin: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M20.5,16.5 C21.3284271,16.5 22,17.1715729 22,18 L22,30 C22,30.8284271 21.3284271,31.5 20.5,31.5 C19.6715729,31.5 19,30.8284271 19,30 L19,18 C19,17.1715729 19.6715729,16.5 20.5,16.5 Z M27.5,16.5 C28.3284271,16.5 29,17.1715729 29,18 L29,30 C29,30.8284271 28.3284271,31.5 27.5,31.5 C26.6715729,31.5 26,30.8284271 26,30 L26,18 C26,17.1715729 26.6715729,16.5 27.5,16.5 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.745e5ea234960788059ae298150a4302.svg";
export { ForwardRef as ReactComponent };